module.exports = __webpack_public_path__ + "files/208869ba1b233a84c4e678000d17ffbe.png";